import { render } from "./page1.vue?vue&type=template&id=3e38f2b2&scoped=true"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"

import "./page1.vue?vue&type=style&index=0&id=3e38f2b2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e38f2b2"]])

export default __exports__